<template>
	<div>
		<div class="tips-title">结算资金已到达手机端蜘币钱包</div>
		<div style="display: flex;">
			<div style="margin: 22px 0 0 10px;">
				<el-form :inline="true">
					<el-form-item label="年月">
						<el-date-picker v-model="value2" type="month" placeholder="选择月" format="yyyy-MM" @change="monthChange"
							:picker-options="pickerOptions" >
						</el-date-picker>
					</el-form-item>
					<el-form-item label="类别">
						<el-select v-model="form.type" clearable placeholder="请选择">
						<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value"/>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div slot="action" style="margin: auto 0;">
				<el-button size="small" type="primary"
					style="margin: 0 0 0 10px;background-color: rgba(40, 168, 207, 1);"
					@click="searchTable">搜索</el-button>
				<el-button size="small" @click="resetTable">重置</el-button>
			</div>
		</div>

		<div style="display: flex; margin: 10px 10px; gap: 40px; font-size: 14px;">
			<span>交易总额：<span style="font-weight: bold; color: #409EFF;">{{ totalAmount }}</span></span>
			<span>分成总额：<span style="font-weight: bold; color: #409EFF;">{{ totalShareAmount }}</span></span>
		</div>

		<div style="margin: 0 10px;">
			<el-table :data="tableData" style="width: 100%" border>
				<el-table-column label="表情名称" align="center" prop="expressionName">
				</el-table-column>
				<el-table-column label="创作者昵称" align="center" prop="nickName">
				</el-table-column>
				<el-table-column label="手机号" align="center" prop="mobile">
				</el-table-column>
				<el-table-column label="月分成数" align="center" prop="monthlyShare">
				</el-table-column>
				<el-table-column label="月交易额" align="center" prop="incomeThisMonth">
				</el-table-column>
				<el-table-column label="平台月分成数" align="center" prop="platformMonthlyShare">
				</el-table-column>
				
				<el-table-column label="分成比例" align="center" prop="shareRatio">
					<template slot-scope="scope">
						{{ scope.row.shareRatio }}%
					</template>
				</el-table-column>
				<el-table-column label="上架时间" align="center" prop="createTime">
				</el-table-column>
				<el-table-column label="结算时间" align="center" prop="settlementTime">
				</el-table-column>
			</el-table>
			<div style="margin-top: 10px; text-align: right;">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="listQuery.pageNo"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="listQuery.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import filmsFilmsInfo from "@/api/apiModel/filmsFilmsInfo"
	export default {
		data() {
			return {
				tableData: [],
				value2: '',
				value3: '',
				value4: '',
				getKey: '',
				totalAmount: 0,
			totalShareAmount: 0,
			total: 0,
				listQuery: {
					pageNo: 1,
					pageSize: 10
				},
				options: [{
					label: '付费蜘影星',
					value: '2'
				},{ 
					label: '付费蜘影剧',
					value: '1'
				},{ 
					label: '付费蜘识课程',
					value: '3'
				}],
				form: {
					month: '',
					type: ''
				},
				pickerOptions:{
					disabledDate(time) {
						// 允许选择当前月及之前的月份，禁用未来月份
						const now = new Date();
						const year = time.getFullYear();
						const month = time.getMonth();
						const nowYear = now.getFullYear();
						const nowMonth = now.getMonth();
						return year > nowYear || (year === nowYear && month > nowMonth);
					}
				}
			}
		},
		mounted() {
			// 设置默认值为上个月
			this.setDefaultMonth();
			this.getList()
		},
		methods: {
			// 设置默认月份为上个月
			setDefaultMonth() {
				const now = new Date();
				let year = now.getFullYear();
				let month = now.getMonth();
				
				// 如果当前是1月份，则上个月是去年的12月份
				if (month === 0) {
					year--;
					month = 11;
				} else {
					month--;
				}
				
				// 格式化月份，确保两位数
				const formattedMonth = (month + 1).toString().padStart(2, '0');
				const lastMonth = `${year}-${formattedMonth}`;
				
				this.value2 = lastMonth;
				this.form.month = lastMonth;
				this.form.type = '';
				
				console.log('默认月份设置为:', lastMonth);
			},
			getList() {
				// 构建请求参数
				const params = {
					...this.listQuery,
					month: this.form.month
				};
				
				// 只有当type有值时才添加到参数中
				if (this.form.type) {
					params.type = this.form.type;
				}
				
				filmsFilmsInfo.spiderSettlementManagement(params).then(res => {
				console.log('结算管理接口返回:', res);
				if(res && res.result){
					const records = res.result.records || res.result || [];
					const recordList = Array.isArray(records) ? records : [];
					this.tableData = recordList;
					this.total = res.result.total || recordList.length;
					// 计算交易总额
					this.totalAmount = recordList.reduce((sum, item) => {
						return sum + (Number(item.incomeThisMonth) || 0);
					}, 0);
					// 计算分成总额
					this.totalShareAmount = recordList.reduce((sum, item) => {
						return sum + (Number(item.monthlyShare) || 0);
					}, 0);
				} else {
					this.tableData = [];
					this.total = 0;
					this.totalAmount = 0;
					this.totalShareAmount = 0;
				}
			}).catch(err => {
				console.error('获取结算数据失败:', err);
				this.tableData = [];
				this.total = 0;
				this.totalAmount = 0;
				this.totalShareAmount = 0;
			})
			},
			handleSelectionChange() {

			},
			openDetails() {

			},
			searchTable() {
				// 搜索时重置页码
				this.listQuery.pageNo = 1;
				this.getList()
			},
			resetTable() {
				this.setDefaultMonth();
				// 重置时重置页码
				this.listQuery.pageNo = 1;
				this.getList()
			},
			monthChange(e) {
			this.form.month = e;
			this.listQuery.pageNo = 1;
			this.getList();
		},
			handleSizeChange(val) {
				this.listQuery.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				this.listQuery.pageNo = val;
				this.getList();
			}
		}
	}
</script>

<style lang="less" scoped>

.tips-title {
	margin: 22px 0 0 10px; margin: 22px 0px 0px 10px;
    color: #00c97e;
    background: #f5f7fa;
    height: 35px;
    line-height: 35px;
    font-size: 17px;
}

</style>